import React, { Component } from 'react';
import { MODAL_DATA_FAILED_TO_LOAD } from '../../util/enums/EnumModals';

class ModalDataFailedToLoad extends Component {
  static modalType() {
    return MODAL_DATA_FAILED_TO_LOAD;
  }

  static reducer() {
    return null;
  }

  static title() {
    return 'Failed to load';
  }

  render() {
    return (
      <div className="alert alert-danger" role="alert">
        <span className="glyphicon glyphicon-exclamation-sign" /> Modal data
        failed to load. Please try again or refresh the page.
      </div>
    );
  }
}

export default ModalDataFailedToLoad;
